import React, { memo } from 'react';
import { type ContentColumnReadPolicy } from './content-column-read.ts';
import { type ContentColumnReadContent } from './content-column-read.ts';
import styles from './content-column-value-view.module.css';

/**
 * Field-owned wrappers preserve V1 spacing, empty states and excerpt image fitting.
 */
export const ContentColumnValueView = memo(function ContentColumnValueView({
  content,
  renderValue
}: {
  readonly content: ContentColumnReadContent<string>;
  readonly renderValue: ContentColumnReadPolicy['renderDatasourceValue'];
}) {
  if (!content.items.length) {
    return null;
  }

  return (
    <ul className={styles.value}>
      {content.items.map((item) => (
        <li key={item.key}>
          {item.state.status === 'ready' ? (
            item.state.value.kind === 'value' ? (
              renderValue(item.state.value.value, {
                openLinksInNewTab: content.openLinksInNewTab
              })
            ) : item.state.value.kind === 'empty' && item.state.value.padded ? (
              <div className={styles.empty}>&nbsp;</div>
            ) : (
              <>&nbsp;</>
            )
          ) : item.state.status === 'loading' ? (
            <span className={styles.loading}>
              &nbsp;
              <span
                className={styles.placeholder}
                style={{ minWidth: content.loadingWidth }}
              />
            </span>
          ) : (
            <>&nbsp;</>
          )}
        </li>
      ))}
    </ul>
  );
});
